export const worklistCopyIt = {
    worklist: "Elenco delle attività",
    yourTasks: "Le Sue attività",
    description:
        "Completi i moduli del clinico, i consensi e le informazioni mancanti sull'evento per tutti i Suoi pazienti.",
    emptyTitle: "È aggiornato",
    emptyDescription: "Nessuna attività del clinico in attesa per il momento.",
    noMatchingTasks: "Nessuna attività corrispondente",
    noMatchingTasksDescription: "Provi a modificare la ricerca, la scheda o i filtri.",
    complete: "Completa",
    completeDetails: "Completa le informazioni",
    completeDetailsPanelDescription: "Inserisca le informazioni mancanti, quindi torni al Suo elenco delle attività.",
    signConsent: "Firma il consenso",
    closePanel: "Chiudi il pannello",
    noTaskSelected: "Selezioni un'attività",
    noTaskSelectedDescription:
        "Scelga una riga per completare qui un modulo, un consenso o informazioni mancanti sull'evento.",
    openDiary: "Apri il diario",
    openPatient: "Apri il paziente",
    toDo: "Da fare",
    refresh: "Aggiorna",
    forms: "Moduli",
    details: "Informazioni",
    archived: "Archiviate",
    archive: "Archivia",
    archiveAll: "Archivia tutto",
    restoreAll: "Ripristina tutto",
    tasksSelected: (count: number) => (count === 1 ? "1 attività selezionata" : `${count} attività selezionate`),
    selectedTasksDescription: "Scelga un'azione per le attività selezionate.",
    selectTask: "Seleziona l'attività",
    selectAllTasks: "Seleziona tutte le attività",
    restore: "Ripristina",
    archiveSucceeded: (count: number) => (count === 1 ? "Attività archiviata." : `${count} attività archiviate.`),
    archiveFailed: "Impossibile archiviare questa attività. Riprovi.",
    restoreSucceeded: (count: number) => (count === 1 ? "Attività ripristinata." : `${count} attività ripristinate.`),
    restoreFailed: "Impossibile ripristinare questa attività. Riprovi.",
    emptyArchivedTitle: "Niente di archiviato",
    emptyArchivedDescription: "Le attività che archivia restano qui finché non le ripristina.",
    allPeople: "Tutte le persone",
    peopleFilterLabel: "Persone",
    selectPeople: "Seleziona i clinici",
    organisationFilterLabel: "Organizzazione",
    allOrganisations: "Tutte le organizzazioni",
    taskTypeFilterLabel: "Tipo di attività",
    allTaskTypes: "Tutti i tipi di attività",
    searchTasks: "Cerca attività",
    clearSearch: "Cancella la ricerca delle attività",
    filterTasks: "Filtra le attività",
    filterTasksDescription: "Scelga le persone, l'organizzazione e il tipo di attività.",
    taskCompleteTitle: "Attività salvata",
    taskCompleteDescription: "Passi alla persona successiva del Suo elenco delle attività quando lo desidera.",
    taskCompleteAllDoneTitle: "Tutto completato",
    taskCompleteAllDoneDescription: "Non ci sono più attività in questo elenco.",
    continueToNextTask: "Passa all'attività successiva",
    doNext: "Da fare in seguito",
    doNextDescription: (task: string, patientName: string, hospitalNumber: string | null) =>
        hospitalNumber
            ? `${task} per ${patientName}. Numero di cartella clinica: ${hospitalNumber}`
            : `${task} per ${patientName}`,
    nextPatientTask: (name: string) => `Successivo: ${name}`,
    returnToWorklist: "Torna all'elenco delle attività",
    patient: "Paziente",
    hospitalNumber: "Numero di cartella clinica",
    task: "Attività",
    injectionDetailsTask: "Informazioni sull'iniezione",
    surgeryDetailsTask: "Informazioni sull'operazione",
    shockwaveDetailsTask: "Informazioni sulle onde d'urto",
    procedureDetailsTask: "Informazioni sull'intervento",
    consentTask: "Consenso",
    due: "Scadenza",
    status: "Stato",
    actions: "Azioni",
    dueLabel: "Da fare",
    blockedLabel: "Bloccata",
    incompleteLabel: "Incompleta",
    blockedBy: (blocker: string) => `Completi prima: ${blocker}`,
    truncatedNotice: (total: number, shown: number) =>
        `Visualizzazione dei primi ${shown} diari su ${total} che includono moduli del clinico. Restringa il Suo elenco dei pazienti per vedere gli altri.`,
    unknownPatient: "Paziente sconosciuto",
    notDefined: "Non definito",
    loading: "Caricamento dell'elenco delle attività…",
    errorLoading: (message: string) => `Impossibile caricare l'elenco delle attività: ${message}`,
    taskCount: (count: number) => (count === 1 ? "1 attività" : `${count} attività`),
};
